import { render, staticRenderFns } from "./AbsentExamsWidget.vue?vue&type=template&id=70016fea"
import script from "./AbsentExamsWidget.vue?vue&type=script&lang=js"
export * from "./AbsentExamsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70016fea')) {
      api.createRecord('70016fea', component.options)
    } else {
      api.reload('70016fea', component.options)
    }
    module.hot.accept("./AbsentExamsWidget.vue?vue&type=template&id=70016fea", function () {
      api.rerender('70016fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/AbsentExamsWidget.vue"
export default component.exports